namespace TabAurous.ProductDevelopment {
    export namespace CustomerRequirementStoneItemsService {
        export const baseUrl = 'ProductDevelopment/CustomerRequirementStoneItems';

        export declare function Create(request: Serenity.SaveRequest<CustomerRequirementStoneItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<CustomerRequirementStoneItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<CustomerRequirementStoneItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<CustomerRequirementStoneItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ProductDevelopment/CustomerRequirementStoneItems/Create",
            Update = "ProductDevelopment/CustomerRequirementStoneItems/Update",
            Delete = "ProductDevelopment/CustomerRequirementStoneItems/Delete",
            Retrieve = "ProductDevelopment/CustomerRequirementStoneItems/Retrieve",
            List = "ProductDevelopment/CustomerRequirementStoneItems/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>CustomerRequirementStoneItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
